import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {

  constructor(
    private msalService: MsalService, 
    private msalBroadcastService: MsalBroadcastService) {}

  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_BY_CODE_START),
      )
      .subscribe((result: EventMessage) => {
        console.log('Token acquisition started');
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.checkAndRefreshToken();
      });
  }

  checkAndRefreshToken() {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      const request = {
        scopes: ['user.read'],
        account: accounts[0]
      };

      this.msalService.acquireTokenSilent(request).subscribe({
        next: (result) => {
          console.log('Token acquired silently', result);
        },
        error: (error) => {
          console.log('Silent token acquisition failed, acquiring by redirect', error);
          this.msalService.acquireTokenRedirect(request);
        }
      });
    }
  }

  title = 'frontend';
}
